import { GraphQLErrors } from '@apollo/client/errors';
import { GraphQLExtensions } from '../../types';

export const REQUEST_TIMEOUT = 'request timed out';

export const isNetworkErrorInResponse = (graphQLErrors: GraphQLErrors) =>
    graphQLErrors.some(
        error => !!error && (error.extensions as GraphQLExtensions | undefined)?.reason === REQUEST_TIMEOUT
    );
